// Func = limiting Scope for this file
(function(){
	
	function resizeWindow(){

	}
	function scrollDown(){
		let top = $(document).scrollTop();
		if (top > 0) {

		} else {

		}
	} 
	// change book link if screen below 1200px (tablet)
	function booklink(){
		if (window.innerWidth <= 1200){
			let linkTable = document.getElementById("btn-reserve-table");
			linkTable.setAttribute("href", "https://www.opentable.com/r/harvest-table-reservations-st-helena");
			linkTable.classList.remove("js-table");
		}
	}

	/*MOBILE MENU NAV
	****************************************************************/
	
	//Open Navigation
	$('#menu-btn').click(function(event) {
		$('html').addClass('hide-overflow');
		$('.navigation').addClass('open');
		$('.navigation').stop().animate({left:'0px'},{duration:300});
		if($('.navigation ul li a').hasClass('.item-open')){
			$(".item-open").get(0).scrollIntoView(false);
		}
	});
	$('.close-menu').click(function(event) {
		event.preventDefault();
		$('html').removeClass('hide-overflow');
		$('.navigation').removeClass('open');
		$('.navigation').stop().animate({left:'100%'},{queue:false,duration:300});
	});

	// Move to the section and close menu tab
	$('a.scrollMenu').click(function(event) {
		if($(document).width() > 600){
			event.preventDefault();
			event.stopPropagation();
			let $thisHref = $(this).attr('href').split('#')[1];

				let hrefTop = $('#'+$thisHref).offset().top + (-105);
				$('html,body').animate({scrollTop:hrefTop});
			
			$('html').removeClass('hide-overflow');
			$('.navigation').removeClass('open');
			$('.navigation').stop().animate({left:'100%'},{queue:false,duration:300});
		} 
		
	});

	$(document).ready(function () {

		$('.sym-slides').slick();

		
		if (document.querySelector('.uvp')){
			setTimeout( ()=> document.querySelector('.uvp').classList.add('fade-in'),0);
		}
		if (document.querySelector('.arrow-home')){
			setTimeout( ()=> document.querySelector('.arrow-home').classList.add('fade'),0);
		}
		if (document.querySelector('main')){
			setTimeout( ()=> document.querySelector('main').classList.add('fade'),0);
		}
		if (document.querySelector('footer')){
			setTimeout( ()=> document.querySelector('footer').classList.add('fade'),0);
		}
		// if (document.querySelector('#container-reasons content-reasons').firstChild){
		// 	setTimeout( ()=> document.querySelector(('#container-reasons content-reasons').firstChild).classList.add('active'),0);
		// }

		//Call function with browser is resized.
		$(window).resize(function (event) {
			resizeWindow();
		});
		resizeWindow();

		//Acts when scroll down page.
		$(window).scroll(function (event) {
			scrollDown();
		});

		//pop in hardcoded
		$('.special-popin__call').click(function(){
			$('.special-popin__content').addClass('active');
		});
		$('.special-popin__content .closepopin').click(function(){
			$('.special-popin__content').removeClass('active');
		});
		// $('.special-popin__content .btncta').click(function(){
		// 	ga('send', 'event', 'popup', 'click', 'staylonger-btn');
		// })
		

		// use this function if you need to change the reserve button link in some screens -- uncomment also js-table function
		// booklink();

		// Main Nav Dropdown
		// $("#primary-nav li").hover(function(){
		// 	$(this).addClass("hover");
		// 	$('ul.submenu',this).fadeIn(200);

		// }, function(){
		// 	$(this).removeClass("hover");
		// 	$('ul.submenu',this).fadeOut(200);
		// });

		// Main Menu Remove Active State
		$("#primary-nav li a").each(function(){
			$(this).removeClass('active');	
		});

		// Main Menu Add Active State
		$("#primary-nav li a").on('click', function () {
			$('#primary-nav li a').removeClass('active');
			$(this).addClass('active');	
		});

		// Nav submenu mobile
		$('.navigation.overlay ul li.primary-nav-2').click(function(){
			console.log('click');
			$('li.primary-nav-2 .sub-sub-menu').fadeToggle( "slow", "linear" );
		});


		$('.book-now').on('click', function () {
			if (typeof ga == 'function') ga('send', 'event', 'reservations', 'click', 'book now');
		});
		//this class should be add to the header widget submit button
		$('.bookNow').on('click', function () {
			if (typeof ga == 'function') ga('send', 'event', 'header widget', 'click', 'book now');
		});

		// Syncing slides

		function createSliders(){
			return function(){
				for(let i = 0; i < 5; i++) {
					const gallery_name = '.slide-gallery-'+i;
					const nav_name = '.nav-gallery-'+i;

					$(gallery_name).slick({
					    asNavFor: nav_name,
					    slidesToShow: 1,
						slidesToScroll: 1,
					    swipeToSlide: true
					});

					$(nav_name).slick({
					  	asNavFor: gallery_name,
					    slidesToShow: 5,
					  	slidesToScroll: 0,
					    swipeToSlide: true,
					  	centerMode: false,
					    focusOnSelect: true,
					    slidesPerRow: 1
					});
					// $('.slide-gallery-'+i).on('beforeChange', function(event, slick, currentSlide, nextSlide){
					// 	$('.nav-gallery-'+i).slick('slickGoTo', nextSlide);
					// });
				}
			}
		} 
		createSliders()();

		// Menu navigation inside Fancybox menu content
		$('.js-menu-link').on('click', function () {
			$('.js-menu-link').each(function(){
				$(this).removeClass('active');
			});
			$(this).addClass('active');
			const idMenu = $(this).attr('id');
			//console.log(idMenu);
			const arrayNum = idMenu.split("-");
			//const idNum = idMenu.substr(idMenu.length - 1);
			const idNum = arrayNum[arrayNum.length - 1];
			const containerMenu = $(this).parent().parent().parent();
			//console.log(containerMenu);
			$("#"+containerMenu.attr('id')+" .img-menu").each(function(){
				$(this).fadeOut(200);
				//console.log($(this));
			});
			$("#"+containerMenu.attr('id')+" .content-menu").each(function(){
				$(this).fadeOut(200);
				//console.log($(this));
			});
			setTimeout(function(){
				$("#"+containerMenu.attr('id')+" #img-menu-"+idNum).fadeIn(200);
				$("#"+containerMenu.attr('id')+" #content-menu-"+idNum).fadeIn(200);
			},200)
			
		});
	

		// Tabs for mobile event fancybox
		$('.tab-rfp').on('click', function () {
			$('.tab-rfp').removeClass('active');
			if ($(this).attr('id') === "js-rfp-tab2"){
				$('.quad-rfp.content-rfp').fadeOut(200, "linear");
				$('.quad-rfp.green-bg').fadeIn(200, "linear");

			}
			else{
				$('.quad-rfp.content-rfp').fadeIn(200, "linear");
				$('.quad-rfp.green-bg').fadeOut(200, "linear");
			}
			$(this).addClass('active');
		});

		/* show open-table widget when click reserve button */
		// $('.js-table').on('click', function () {
		// 	$("#js-table-container").fadeIn(200).css('display','table');
		// 	if (!$('.phone-table').hasClass('loaded')){
		// 		$('.ot-dtp-picker').append("<div class='phone-table'><a href='tel:707-967-4695' class='phone'> 707-967-4695 </a></div>");
		// 		$('.phone-table').addClass("loaded");
		// 	}
			
		// });

		/* close open-table widget when click any area outside the widget */
		// $('#js-table-container').on('click', function(event){		
		// 	if ( $('.ot-dtp-picker').has(event.target).length == 0 //checks if descendants was clicked
	 //            &&
	 //            !$('.ot-dtp-picker').is(event.target) //checks if this itself was clicked
	 //          	){
		// 			$("#js-table-container").fadeOut(200);
		// 		} 
		// });

		/* Sign up loader */
		$('.js-btn-signup').on('click', function(event){	
			event.preventDefault();	
			$("#container-signup-form").fadeIn(100);
			$("#header").fadeOut(400);
			$(".footer-web").fadeIn(800);
			$(".container-form").fadeIn(1500);
			setTimeout(function(){
				$(".container-form").addClass('container-pop');
				$("#container-signup-form").addClass('bg-email-full');
			}, 500);
		});
		
		/* close sign up */
		$('.close-signup').on('click', function(event){		
			$(".container-form").removeClass('container-pop');
			$("#container-signup-form").removeClass('bg-email-full');
			setTimeout(function(){
				$("#container-signup-form").fadeOut(400);
				$("#header").fadeIn(200);
				$(".footer-web").fadeOut(200);
				$(".container-form").fadeOut(100);
			}, 200);
		});

		// Set email value from footer to sigunp popup
		let valueEmail = document.getElementById('enter-email');
		let signupEmail = document.getElementById('email-signup_email_address');

		valueEmail.addEventListener('change', function () {
			signupEmail.value = valueEmail.value;
		})

		
		// Gallery content display lateral box when click 
		$('.js-menu-lateral').on('click', function () {
			const idMenu = $(this).attr('id'); // Get variables from slide clicked 
			const identifier = idMenu.split("-"); // split the variables in an array
			const idBlog = identifier[1]; // To know which quad you are modifying
			const idSlide = identifier[2]; // to know the slide to show

			//Remove class active of all slides inside the quad you're clicked
			$('#lateral-container-'+idBlog+' .content-lateral').each(function(){ 
				$(this).removeClass('active');
				$(this).fadeOut(200);
			});
			//Add class active to the content you want to show (based on quad id and slide number)
			setTimeout(function(){
				$('#content-'+idBlog+'-'+idSlide).addClass('active');
			},200)
		});

		//Check in and check out datepicker for booking engine
		$( "#CheckIn" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			changeMonth: true,
			numberOfMonths: 2,
			minDate: 0,
			onSelect: function( selectedDate ) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 3);
				$( "#CheckOut" ).datepicker( "setDate", newDate );
				$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
			}
		});
		$( "#CheckOut" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			changeMonth: true,
			numberOfMonths: 2,
			onSelect: function( selectedDate ) {
				//$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
			}
		});

		// Remove atr
		$('#secondary-nav').removeAttr('aria-label');

		$('.slick-prev').removeAttr('aria-label');
		$('.slick-next').removeAttr('aria-label');


		// Map: Return to previous page button. Change body id to match map template's name.
		//$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');
		
	});

	$(window).on('load', function() {
		//Preloader
		$('#preloader').fadeOut('slow');
	    $('body').css({'overflow':'visible'});
		
	});

}());